<template>
  <div>
    <v-alert
      class="text-center"
      :value="!!alert"
      dismissible
      border="left"
      type="error"
      @input="closeAlert"
    >
      {{ alert }}
    </v-alert>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('Alert', ['alert'])
  },

  methods: {
    ...mapMutations('Alert', ['set_alert']),
    closeAlert() {
      this.set_alert({})
    }
  }
}
</script>